export default {
      id: "nba-usage",
      viewBox: "0 0 201 166",
      url: "/" + "images/icons.3.109.2.svg#nba-usage",
      toString: function () {
        return this.url;
      }
    }